<!--
 * @Author: LiuMeiYu
 * @Date: 2023-01-09 14:55:19
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-06-15 17:04:32
 * @FilePath: \nivara\src\views\forgotPassword\forgotPasswordView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="forgot-password-container">
    <div class="header-container">
      <div class="header-content">
        <div class="header-logo">
          <router-link to="/home">
            CardSwap
          </router-link>
        </div>
        <div class="header-menu">
          <div class="header-menu-item">
          </div>
        </div>
        <div class="header-login-forgot">
          <div class="header-btn-login">Log in</div>
          <router-link to="/register">
            <div class="header-btn-forgot">Register</div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="forgot-password-content">
      <el-tabs
        v-model="forgotTabsActive"
        class="forgot-tabs"
        @tab-click="forgotTabHandleClick"
        type="card"
      >
        <el-tab-pane label="Phone" name="phone">
          <el-form
            class="forgot-phone-form"
            label-position="top"
            label-width="100px"
            :model="forgotPhoneForm"
          >
            <el-form-item label="Phone" :required="true">
              <el-input
                v-model="forgotPhoneForm.phone"
                placeholder="Enter your phone number"
                ref="forgotPhonePhoneRef"
                autofocus
              >
                <template #prepend>
                  <el-select v-model="countryCode" style="width: 150px">
                    <el-option
                      v-for="item in countryCodeListData"
                      :key="item.id"
                      :label="item.name_en + ' ' + item.code"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="Verification code" :required="true">
              <el-input
                v-model="forgotPhoneForm.code"
                placeholder="Enter the code you received"
                ref="forgotPhoneCodeRef"
                maxlength="4"
              >
                <template #append>
                  <div class="forgot-code-text" @click="sendForgotPhoneCode">
                    {{ forgotPhoneCodeText }}
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="New Password" :required="true">
              <el-input
                v-model="forgotPhoneForm.password"
                type="password"
                maxlength="20"
                show-password
                ref="forgotPhonePasswordRef"
                placeholder="Set your password, at least 5 characters."
              />
            </el-form-item>
          </el-form>
          <el-button
            class="forgot-phone-email"
            @click="forgotPasswordByPhoneOrEmail('phone')"
            >Submit</el-button
          >
        </el-tab-pane>
        <el-tab-pane label="Email" name="email">
          <el-form
            class="forgot-email-form"
            label-position="top"
            label-width="100px"
            :model="forgotEmailForm"
          >
            <el-form-item label="Email" :required="true">
              <el-input
                v-model="forgotEmailForm.email"
                placeholder="Please enter your email address"
                ref="forgotEmailEmailRef"
                autofocus
              />
            </el-form-item>
            <el-form-item label="Verification code" :required="true">
              <el-input
                v-model="forgotEmailForm.code"
                maxlength="4"
                placeholder="Enter the code you received"
                ref="forgotEmailCodeRef"
              >
                <template #append>
                  <div class="forgot-code-text" @click="sendForgotEmailCode">
                    {{ forgotEmailCodeText }}
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="New Password" :required="true">
              <el-input
                v-model="forgotEmailForm.password"
                maxlength="20"
                type="password"
                show-password
                ref="forgotEmailPasswordRef"
                placeholder="Set your password, at least 5 characters."
              />
            </el-form-item>
          </el-form>
          <el-button
            class="forgot-phone-email"
            @click="forgotPasswordByPhoneOrEmail('email')"
            >Submit</el-button
          >
        </el-tab-pane>
      </el-tabs>
      <div class="back-to-login">
        <router-link to="/login">Back to Log in</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "@vue/runtime-core";
import { ElNotification } from "element-plus";
import {
  getCountryCodeApi,
  updatePasswordByWhatappApi,
  updatePasswordByEmailApi,
  getWhatsAppVerificationCodeApi,
  getUserSecurityInfoApi,
} from "../../api/index";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "ForgotPassword",
  components: {},
  setup() {
    onMounted(() => {
      getCountryCode();
    });
    const router = useRouter();
    const state = reactive({
      countryCodeListData: [],
    });
    const countryCode = ref("234");
    const forgotPhonePhoneRef = ref(null);
    const forgotPhoneCodeRef = ref(null);
    const forgotPhonePasswordRef = ref(null);
    const forgotEmailEmailRef = ref(null);
    const forgotEmailCodeRef = ref(null);
    const forgotEmailPasswordRef = ref(null);
    // forgot tabs star
    const forgotTabsActive = ref("phone");
    const forgotTabHandleClick = (tab) => {
      console.log(tab.paneName);
      if (tab.paneName === "phone") {
        forgotEmailForm.email = "";
        forgotEmailForm.code = "";
        forgotEmailForm.password = "";
      } else {
        forgotPhoneType.value = "1";
        forgotPhoneForm.phone = "";
        forgotPhoneForm.code = "";
        forgotPhoneForm.password = "";
      }
    };
    // forgot tabs end

    // forgot phone star
    const forgotPhoneForm = reactive({
      phone: "",
      code: "",
      password: "",
    });
    const forgotPhoneType = ref("1");
    const forgotPhoneCodeText = ref("Send");
    let forgotPhoneCodeInterval = ref(null);
    let forgotPhoneCodeTime = ref(60);
    // 发送验证码反正重复点击
    const isSendforgotPhoneCodeAgain = ref(true);
    // 发送手机验证码
    const sendForgotPhoneCode = () => {
      const telStr = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
      // 是否可以再次点击
      if (isSendforgotPhoneCodeAgain.value) {
        // 已输入手机号
        if (forgotPhoneForm.phone) {
          // 手机号正确
          if (telStr.test(forgotPhoneForm.phone)) {
            let data = {
              whatsapp: countryCode.value + forgotPhoneForm.phone,
            };
            getWhatsAppVerificationCodeApi(data).then((res) => {
              console.log("getWhatsAppVerificationCodeApi", res);
              if (res.data.success) {
                ElNotification({
                  title: "Tips",
                  message: "Verification code has been sent",
                  type: "success",
                });
                isSendforgotPhoneCodeAgain.value = false;
                forgotPhoneCodeInterval = setInterval(() => {
                  if (forgotPhoneCodeTime.value > 0) {
                    forgotPhoneCodeText.value = forgotPhoneCodeTime.value + "s";
                    forgotPhoneCodeTime.value--;
                  } else {
                    isSendforgotPhoneCodeAgain.value = true;
                    forgotPhoneCodeTime.value = 60;
                    forgotPhoneCodeText.value = "Send";
                    clearInterval(forgotPhoneCodeInterval);
                  }
                }, 1000);
              } else {
                ElNotification({
                  title: "Tips",
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          } else {
            ElNotification({
              title: "Tips",
              message:
                "The format of the phone number you entered is incorrect.",
              type: "error",
            });
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "Please Enter your phone number.",
            type: "error",
          });
        }
      }
    };
    // forgot phone end
    // forgot email star
    const forgotEmailForm = reactive({
      email: "",
      code: "",
      password: "",
    });
    const forgotEmailCodeText = ref("Send");
    let forgotEmailCodeInterval = ref(null);
    let forgotEmailCodeTime = ref(60);
    // 发送验证码反正重复点击
    const issendForgotEmailCodeAgain = ref(true);
    // 发送邮箱验证码
    const sendForgotEmailCode = () => {
      const emailStr = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      // 是否可以再次点击
      if (issendForgotEmailCodeAgain.value) {
        // 已输入邮箱地址
        if (forgotEmailForm.email) {
          // 邮箱地址正确
          if (emailStr.test(forgotEmailForm.email)) {
            let data = {
              username: forgotEmailForm.email,
            };
            getUserSecurityInfoApi(data).then((res) => {
              console.log("getUserSecurityInfoApi", res);
              if (res.data.success) {
                ElNotification({
                  title: "Tips",
                  message: "Verification code has been sent",
                  type: "success",
                });
                issendForgotEmailCodeAgain.value = false;
                forgotEmailCodeInterval = setInterval(() => {
                  if (forgotEmailCodeTime.value > 0) {
                    forgotEmailCodeText.value = forgotEmailCodeTime.value + "s";
                    forgotEmailCodeTime.value--;
                  } else {
                    issendForgotEmailCodeAgain.value = true;
                    forgotEmailCodeTime.value = 60;
                    forgotEmailCodeText.value = "Send";
                    clearInterval(forgotEmailCodeInterval);
                  }
                }, 1000);
              } else {
                ElNotification({
                  title: "Tips",
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          } else {
            ElNotification({
              title: "Tips",
              message:
                "The format of the email address you entered is incorrect.",
              type: "error",
            });
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "Please Enter your email address.",
            type: "error",
          });
        }
      }
    };
    // forgot email end

    // 修改密码
    const forgotPasswordByPhoneOrEmail = (type) => {
      if (type === "phone") {
        console.log("手机");
        if (forgotPhoneForm.phone) {
          let telStr = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
          if (telStr.test(forgotPhoneForm.phone)) {
            if (forgotPhoneForm.code) {
              if (forgotPhoneForm.password) {
                if (forgotPhoneForm.password.length >= 5) {
                  updatePasswordByWhatApp();
                } else {
                  forgotPhonePasswordRef.value.focus();
                  ElNotification({
                    title: "Tips",
                    message: "Set your password, at least 5 characters.",
                    type: "error",
                  });
                }
              } else {
                forgotPhonePasswordRef.value.focus();
                ElNotification({
                  title: "Tips",
                  message: "Please Enter your password",
                  type: "error",
                });
              }
            } else {
              forgotPhoneCodeRef.value.focus();
              ElNotification({
                title: "Tips",
                message: "Please Enter the code you received",
                type: "error",
              });
            }
          } else {
            forgotPhonePhoneRef.value.focus();
            ElNotification({
              title: "Tips",
              message:
                "The format of the phone number you entered is incorrect.",
              type: "error",
            });
          }
        } else {
          forgotPhonePhoneRef.value.focus();
          ElNotification({
            title: "Tips",
            message: "Please enter your phone number",
            type: "error",
          });
        }
      } else {
        console.log("邮箱");
        if (forgotEmailForm.email) {
          let emailStr = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
          if (emailStr.test(forgotEmailForm.email)) {
            if (forgotEmailForm.code) {
              if (forgotEmailForm.password) {
                if (forgotEmailForm.password.length >= 5) {
                  updatePasswordByEmail();
                } else {
                  forgotEmailPasswordRef.value.focus();
                  ElNotification({
                    title: "Tips",
                    message: "Set your password, at least 5 characters.",
                    type: "error",
                  });
                }
              } else {
                forgotEmailPasswordRef.value.focus();
                ElNotification({
                  title: "Tips",
                  message: "Please Enter your password",
                  type: "error",
                });
              }
            } else {
              forgotEmailCodeRef.value.focus();
              ElNotification({
                title: "Tips",
                message: "Please Enter the code you received",
                type: "error",
              });
            }
          } else {
            forgotEmailEmailRef.value.focus();
            ElNotification({
              title: "Tips",
              message:
                "The format of the email address you entered is incorrect.",
              type: "error",
            });
          }
        } else {
          forgotEmailEmailRef.value.focus();
          ElNotification({
            title: "Tips",
            message: "Please Enter your email address.",
            type: "error",
          });
        }
      }
    };
    // 通过WhatsApp修改密码
    const updatePasswordByWhatApp = () => {
      let data = {
        whatsapp: countryCode.value + forgotPhoneForm.phone,
        verify_code: forgotPhoneForm.code,
        new_password: forgotPhoneForm.password,
      };
      updatePasswordByWhatappApi(data).then((res) => {
        console.log("updatePasswordByWhatappApi", res);
        if (res.data.success) {
          ElNotification({
            title: "Tips",
            message: "Success",
            type: "success",
          });
          router.push({
            path: "/login",
          });
        } else {
          if (
            res.data.code == "user.001" ||
            res.data.msg == "Necessary parameter error"
          ) {
            ElNotification({
              title: "Tips",
              message: "Network Error",
              type: "error",
            });
          } else if (
            res.data.code == "user.012" ||
            res.data.msg == "Please enter a correct verification code"
          ) {
            forgotPhoneCodeRef.value.focus();
            ElNotification({
              title: "Tips",
              message: res.data.msg,
              type: "error",
            });
          } else {
            ElNotification({
              title: "Tips",
              message: res.data.msg,
              type: "error",
            });
          }
        }
      });
    };
    // 通过邮箱修改密码
    const updatePasswordByEmail = () => {
      let data = {
        email: forgotEmailForm.email,
        verify_code: forgotEmailForm.code,
        new_password: forgotEmailForm.password,
      };
      updatePasswordByEmailApi(data).then((res) => {
        console.log("updatePasswordByEmailApi", res);
        if (res.data.success) {
          ElNotification({
            title: "Tips",
            message: "Success",
            type: "success",
          });
          router.push({
            path: "/login",
          });
        } else {
          if (
            res.data.code == "user.001" ||
            res.data.msg == "Necessary parameter error"
          ) {
            ElNotification({
              title: "Tips",
              message: "Network Error",
              type: "error",
            });
          } else if (
            res.data.code == "user.012" ||
            res.data.msg == "Please enter a correct verification code"
          ) {
            forgotEmailCodeRef.value.focus();
            ElNotification({
              title: "Tips",
              message: res.data.msg,
              type: "error",
            });
          } else {
            ElNotification({
              title: "Tips",
              message: res.data.msg,
              type: "error",
            });
          }
        }
      });
    };
    const getCountryCode = () => {
      getCountryCodeApi().then((res) => {
        console.log("getCountryCodeApi：", res);
        if (res.data.success) {
          if (res.data.data.length > 0) {
            state.countryCodeListData = res.data.data;
          } else {
            state.countryCodeListData = [];
            countryCode.value = "233";
          }
        }
      });
    };
    return {
      countryCode,
      forgotPhonePhoneRef,
      forgotPhoneCodeRef,
      forgotPhonePasswordRef,
      forgotEmailEmailRef,
      forgotEmailCodeRef,
      forgotEmailPasswordRef,
      forgotTabsActive,
      forgotTabHandleClick,
      forgotPhoneForm,
      forgotPhoneType,
      forgotPhoneCodeText,
      forgotPhoneCodeInterval,
      sendForgotPhoneCode,
      forgotEmailForm,
      forgotEmailCodeText,
      sendForgotEmailCode,
      forgotPasswordByPhoneOrEmail,
      ...toRefs(state),
    };
  },
});
</script>
<style lang="less" scoped>
.forgot-password-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../../assets/images/login_register_forgot_bg.png");
  background-repeat: no-repeat;
  background-position: left top;
  background-size: cover;
  .header-container {
    position: fixed;
    width: 100%;
    height: 80px;
    top: 0;
    left: 0;
    .header-content {
      height: 100%;
      margin: 0 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #ffffff;
      .header-logo {
        font-size: 20px;
        font-weight: 500;
        a {
          color: #ffffff;
        }
      }
      .header-menu {
        .header-menu-item {
          .el-dropdown-link {
            cursor: pointer;
            display: flex;
            align-items: center;
            color: #ffffff;
          }
        }
      }
      .header-login-forgot {
        display: flex;
        align-items: center;
        .header-btn-login {
          margin-right: 40px;
        }
        .header-btn-forgot {
          padding: 10px 25px;
          border-radius: 10px;
          background-color: #03004d;
          cursor: pointer;
        }
        a {
          color: #ffffff;
        }
      }
    }
  }
  .forgot-password-content {
    width: 420px;
    min-width: 420px;
    padding: 64px;
    background-color: #ffffff;
    border-radius: 12px;
    .forgot-tabs {
      :deep(.el-tabs__header) {
        padding: 4px;
        background-color: #f7fafd;
        border-radius: 12px;
        border: none;
      }
      :deep(.el-tabs__nav) {
        width: 100%;
        display: flex;
        border: none;
      }
      :deep(.el-tabs__item) {
        flex: 1;
        border: none;
      }
      :deep(.el-tabs__item.is-active) {
        border: none;
        border-radius: 12px;
        background-color: #03034d;
        color: #ffffff;
      }
      :deep(.el-form-item) {
        margin-bottom: 10px;
      }
      :deep(.el-form-item__label) {
        padding: 0;
        color: #000000;
      }
    }
    .forgot-code-text {
      width: 40px;
      color: #2d43bf;
      cursor: pointer;
    }
    .forgot-phone-email {
      width: 100%;
      margin-top: 40px;
      margin-bottom: 10px;
      background-color: #03004d;
      border-radius: 10px;
      font-size: 18px;
      color: #ffffff;
    }
    .back-to-login {
      text-align: right;
      cursor: pointer;
      a {
        color: #2dbf38;
      }
    }
    .forgot-agreement {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      margin-top: 60px;
      .agreement-forgot {
        min-width: 20px;
        height: 20px;
        margin-right: 10px;
        cursor: pointer;
      }
      .agreement-forgot-name {
        text-align: left;
        color: #999999;
        span {
          color: #2dbf38;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
